import Vue from 'vue';
const canvas = document.createElement("canvas");
let context = null;
try {
    context = canvas.getContext("2d");
} catch (e){
    // console.log("Canvas not supported");
}

export function getTextWidth(inputText, referenceElement) {
    if(referenceElement instanceof Vue){
        referenceElement = referenceElement.$el;
    }
    let style = getComputedStyle(referenceElement);
    if(!context){
        return  10;
    }
    context.font = style.font;
    return Math.ceil(context.measureText(inputText).width);
}

export function setCaretPosition(elem, caretPos) {
    if(elem != null) {
        if(elem.createTextRange) {
            let range = elem.createTextRange();
            range.move('character', caretPos);
            range.select();
        }
        else {
            if(elem.selectionStart) {
                elem.focus();
                elem.setSelectionRange(caretPos, caretPos);
            }
            else
                elem.focus();
        }
    }
}